import GiftCategoryApi from '@apis/gift/GiftCategoryApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const giftCategoryQueries = createQueryKeys('giftCategory', {
  list: () => ({
    queryKey: ['list'],
    queryFn: () => GiftCategoryApi.getGiftCategories(),
  }),
});

export default giftCategoryQueries;
